/**
 * The published lines' one rule a page applies before it sends them: a row added and never
 * filled in is not a line. The server drops it too, but a page that sent it would number the
 * rows differently from the server, and a refusal about row two would land on the wrong row.
 */

import type { PhoneLine } from '../api';

export function withoutEmptyRows(lines: readonly PhoneLine[]): PhoneLine[] {
  return lines.filter((line) => line.label.trim() !== '' || line.number.trim() !== '');
}

/** The id of a row's number box, which is the API's name for it when a save is refused. */
export function numberFieldOf(row: number): string {
  return `phoneLines.${row}.number`;
}
